import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { memo } from 'react';
import styled from 'styled-components';
import type { IInlineLabelProps } from './InlineLabel.types';

const InlineLabel = ({
	className,
	children,
	label,
	bold,
	labelPlacement = 'right',
}: IInlineLabelProps) => {
	const isLabelString = typeof label === 'string';

	const labelContent = isLabelString ? (
		<LabelText variant="button" bold={bold}>
			{label}
		</LabelText>
	) : (
		label
	);

	return (
		<div className={className}>
			{label && labelPlacement === 'left' && labelContent}
			{children}
			{label && labelPlacement === 'right' && labelContent}
		</div>
	);
};

const LabelText = styled(Text)``;

const Memoized = memo(InlineLabel);
const Styled = styled(Memoized)`
	display: flex;
	align-items: center;

	${LabelText} {
		color: ${({ theme }) => theme.v2.color.neutral[1100]};
	}
	${({ labelPlacement = 'right' }) => {
		if (labelPlacement === 'left') {
			return `${LabelText} { margin-right: 0.75rem; }`;
		}
		return `${LabelText} { margin-left: 0.75rem; }`;
	}}

	${({ theme, disabled }) => {
		if (disabled) {
			return ` ${LabelText} {
                color: ${theme.v2.color.neutral[400]};
            }
        `;
		}
		return ``;
	}}
`;

export { Styled as InlineLabel };
